import $ from "jquery";
import Popper from "popper.js";

window.jQuery = $;
window.$ = $;
global.jQuery = $;
window.Popper = Popper;
global.Popper = Popper;
require("bootstrap");






// WEBPACK FOOTER //
// ./src/misc/bootstrapFix.js